import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { USA_GET_LAST_TRANSACTIONS } from '../../queries';
import { useCardTransactionBridge } from '../../../../utilities/sharedHooks/card';
import MainBodyLayout from '../partials/MainBodyLayout';
import { ReportCardScreensFlow } from '../../constants';
import { CardSettingsContext } from '../../../../contexts/card/settings/context';
import { TransactionItemPlaceholder } from '../../../../components/Placeholders';
import TransactionItemLayout from '../partials/TransactionItemLayout';
import { cardSettingsScreens } from '../constants';

const LastFiveTransactions = () => {
  const { t: translate } = useTranslation();
  const [currentTransactions, setCurrentTransactions] = useState([]);
  const { openScreen } = useContext(CardSettingsContext);
  const history = useHistory();

  const { data: transactionData, isLoading: isLoadingTransaction } =
    useQuery(USA_GET_LAST_TRANSACTIONS);

  const { transactions } = useCardTransactionBridge(currentTransactions);

  useEffect(() => {
    if (!isLoadingTransaction) {
      setCurrentTransactions(transactionData);
    }
  }, [isLoadingTransaction, transactionData, transactions]);

  const closeFlow = () => {
    history.push('/dashboard/card/details');
  };

  return (
    <MainBodyLayout
      withBack
      onPrevClick={() => openScreen(ReportCardScreensFlow.REPORT_CARD_CONFIRM)}
      title={translate('card_disabled')}>
      <div className="mt-4">
        <p className="text-f5 text-dark p-0">{translate('card_order_last_transaction_subtitle')}</p>
        <p className="text-f5 text-dark pt-3">
          {translate('card_order_last_transaction_subtitle_2')}
        </p>
      </div>
      <div className="rounded-extra light-container p-3 mt-4">
        {isLoadingTransaction ? (
          <div>
            <TransactionItemPlaceholder />
            <TransactionItemPlaceholder />
            <TransactionItemPlaceholder />
            <TransactionItemPlaceholder />
          </div>
        ) : (
          transactions?.map((tx) => <TransactionItemLayout key={`${tx.index}-${tx.id}`} tx={tx} />)
        )}
      </div>
      <div
        className={`d-flex flex-row mt-5 pt-3 ${
          isMobile ? 'position-fixed w-95 bg-light pb-3 pe-2' : 'mx-2 px-5'
        }`}
        style={{ bottom: '0', left: '0', zIndex: 100 }}>
        <div
          className="w-100 d-flex flex-row justify-content-between p-0"
          style={{ marginTop: 'auto' }}>
          <button
            onClick={() => {
              openScreen(cardSettingsScreens.NOT_RECOGNIZED_TX);
            }}
            className="btn border-grey border text-f5 mt-4 w-50 me-4"
            type="button">
            {translate('not_recognized_button_label')}
          </button>
          <button
            onClick={() => {
              closeFlow();
            }}
            className="btn btn-primary  text-f5 mt-4 w-50"
            type="button">
            {translate('confirm_button_label')}
          </button>
        </div>
      </div>
    </MainBodyLayout>
  );
};

export default LastFiveTransactions;
